import { TESTING } from "../../constants/testing";

export const getWorkOrderInstructions = (data, departmentId) =>
  data?.instructions?.find((ins) => ins?.departmentId === departmentId);

export const getTestingCounts = (testing = []) => {
  // Count occurrences of each testId
  const counts = testing.reduce((acc, { testId }) => {
    acc[testId] = (acc[testId] || 0) + 1;
    return acc;
  }, {});

  // Map the counts into readable labels
  const mappedTesting = Object.entries(counts)
    .map(([testId, quantity]) => {
      const test = TESTING.find((ft) => ft.id == testId);
      if (!test) return false;
      return `${quantity} ${test.label}`;
    })
    .filter(Boolean)
    .join(",\n");

  return mappedTesting;
};
